import { render } from "./process.vue?vue&type=template&id=5575e05a&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"

import "./process.vue?vue&type=style&index=0&id=5575e05a&lang=scss&scoped=true"
import "./process.vue?vue&type=style&index=1&id=5575e05a&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5575e05a"]])

export default __exports__